import React from 'react'

function TextField(props) {
  const handleChange = (e, type = 'text') => {
    let data = null
    let value = e.target.value
    let name = e.target.name
    const numbersonly = new RegExp('^[0-9]*$')

    if (type === 'number') {
      if (numbersonly.test(value)) {
        data = value
      }
    } else {
      data = value
    }

    props.onChange(data, name)
  }

  return (
    <div className="w-full mb-4">
      {props.label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {props.label}{' '}
          {props.required && <span className="text-red-500">*</span>}
        </label>
      )}

      {props.type === 'textarea' ? (
        <textarea
          className={
            props.className ??
            'w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
          }
          name={props.name}
          value={props.value ?? ''}
          onChange={(e) => handleChange(e, props.type)}
          id={props.name}
          placeholder={props.placeholder ?? ''}
          maxLength={props.maxLength}
          minLength={props.minLength}
          required={props.required}
          disabled={props.disabled}
        />
      ) : (
        <input
          className={
            props.className ??
            'w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
          }
          minLength={props.minLength ?? undefined}
          maxLength={props.maxLength ?? undefined}
          placeholder={props.placeholder ?? ''}
          disabled={props.disabled}
          name={props.name}
          value={props.value ?? ''}
          required={props.required}
          onChange={(e) => handleChange(e, props.type)}
          type={
            props.type === 'email'
              ? 'email'
              : props.type === 'date'
                ? 'date'
                : props.type === 'number'
                  ? 'text' // Render as text to allow regex validation
                  : 'text'
          }
          id={props.name}
        />
      )}
    </div>
  )
}

export default TextField
